exports.onServiceWorkerUpdateFound = () => window.location.reload(true);
exports.onRouteUpdate = ({ location, prevLocation }) => {
    console.log('new pathname', location.pathname)
    console.log('old pathname', prevLocation ? prevLocation.pathname : null)
  }